/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-underscore-dangle */
import React from 'react';
import { defineMessages, injectIntl } from 'react-intl';
import {
  Typography,
  TextField,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';

const messages = defineMessages({
  hours: {
    id: 'Elearning.hours',
    defaultMessage: '% Hours',
  },
});

const renderTextField = ({
  input,
  label,
  ...custom
}) => (
  <TextField
    label={label}
    {...input}
    {...custom}

  />
);

const ElearningHoursPercent = (props) => {
  const { intl } = props;
  const queryParams = new URLSearchParams(window.location.search);
  const update = queryParams.get('update');
  return (
    <>
      <Typography style={{ marginTop: '10px', marginBottom: '10px' }}>
        {intl.formatMessage(messages.hours)}
      </Typography>
      <Field
        name={update === 'true' ? 'elearning.elearningDurationTarget' : 'elearningDurationTarget'}
        label={intl.formatMessage(messages.hours)}
        style={{ width: '100%' }}
        id="filled-number"
        variant="outlined"
        type="number"
        inputProps={{ min: '0', step: '0.5' }}
        component={renderTextField}
      />
    </>
  );
};

ElearningHoursPercent.propTypes = {
  intl: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  const name = `group_${state.group.selectedGroup._id}`;
  const dataform = state.form[`group_${state.group.selectedGroup._id}`];
  return ({ initialValues: state.group.selectedGroup, form: name, dataform });
}

const connectedGroupForm = reduxForm({
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false,

})(injectIntl(ElearningHoursPercent));

const NewconnectedGroupForm = connect(mapStateToProps, {})(connectedGroupForm);

export default (NewconnectedGroupForm);
